import cn from 'classnames';
import { useContext } from 'react';

import Text from 'components/common/Text';
import { UserContext } from 'components/signUpFunnel/Contexts';
import { BrandContext } from 'context/BrandContext';
import { brandData } from 'helpers/BrandData';
import style from 'styles/components/signUpFunnel/LegalCopy';

import SmartPhoneLegalCopy from './thankYou/smartphone/SmartPhoneLegalCopy';
import ThankYouButton from './thankYou/ThankYouButton';

const LegalCopy = ({ isSmartphoneScreenSize = false, onClick }) => {
  const { brand, postSignupUrl } = useContext(BrandContext);
  const { user } = useContext(UserContext);
  const data = brandData(brand);

  if (!brand) return null;

  const DefaultLegalCopy = () => {
    return (
      <>
        <div className={cn(style.copyContainer, style.background, style[brand], '-ml-4 -mt-20')}>
          <div className="mx-auto flex items-center justify-center">
            <ThankYouButton onClick={onClick} postSignupUrl={postSignupUrl} user={user} />
          </div>
          <div className={cn(style.legalCopy, 'mt-8 pb-8')}>
            <Text brandStylesOverrides="textSm" className="px-2 py-3 text-center">
              Valid for new customers only. Referral credit limited to one per new household
              address, and cannot be combined with any other {data.displayName} offers, promotions,
              or discounts. Your promotional discount recipient can freely choose to skip or cancel
              future deliveries free of charge once they redeem their referral credit.
            </Text>
            <Text brandStylesOverrides="textSm" className="px-2 py-3 text-center">
              You agree to share your {data.displayName} referral link only with your own personal
              connections via email, your own social media accounts, and personal blogs where you
              are the primary content owner. Public distribution on sites where you are not the
              primary content owner, e.g. {data.displayName}’s social media pages and coupon
              websites, is not allowed. We reserve the right to suspend your account and/or revoke
              any and all referral credits at any time if we believe that your credits were
              inappropriately earned.
            </Text>
          </div>
        </div>
      </>
    );
  };

  return isSmartphoneScreenSize ? (
    <SmartPhoneLegalCopy
      onClick={onClick}
      brand={brand}
      postSignupUrl={postSignupUrl}
      user={user}
    />
  ) : (
    <DefaultLegalCopy />
  );
};

LegalCopy.propTypes = {
  isSmartphoneScreenSize: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default LegalCopy;
